module.exports = __webpack_public_path__ + "static/0085-8e0660a809d977276c5f34c7f06ae31e.png";